import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import debounce from 'debounce-promise';

import LoadingSpinner from 'components/loading_spinner';
import Comps from './property_comps';
import { get, put } from 'helpers/api';

import './styles.scss';

export function PropertyComps({ coordinates, paths, type }) {
  const [propertyComps, setPropertyComps] = useState();

  React.useEffect(() => {
    get(paths.index, { params: { type } }).then(setPropertyComps);
  }, []);

  if (!propertyComps) {
    return <LoadingSpinner />;
  }

  function remove(propertyComp) {
    setPropertyComps(propertyComps.filter(comp => comp.id !== propertyComp.id));
  }

  function reorder(dragIndex, hoverIndex) {
    const newPropertyComps = [...propertyComps];
    const movedComp = newPropertyComps.splice(dragIndex, 1)[0];
    newPropertyComps.splice(hoverIndex, 0, movedComp);
    setPropertyComps(newPropertyComps);

    debouncedSave(newPropertyComps);
  }

  const debouncedSave = debounce(save, 250);
  async function save(propertyComps) {
    await put(`${paths.index}/reorder`, {
      propertyComps: propertyComps.map((propertyComp, i) => {
        return {
          ...propertyComp,
          sortOrder: i
        };
      }),
      type
    });
  }

  return (
    <Comps
      coordinates={coordinates}
      paths={paths}
      propertyComps={propertyComps}
      type={type}
      onChange={setPropertyComps}
      onRemove={remove}
      onReorder={reorder}
    />
  );
}

PropertyComps.propTypes = {
  coordinates: PropTypes.object,
  paths: PropTypes.shape({
    index: PropTypes.string.isRequired,
  }).isRequired,
  type: PropTypes.oneOf(['lease', 'sale']),
};

const mapStateToProps = state => ({
  paths: state.propertyComps.paths,
});

export default connect(mapStateToProps)(PropertyComps);
